module.exports = __webpack_public_path__ + "media/images/banner/banner_merger_for_kufu_pc-21a2855ec897d458f6383f7124578fa6.png";